import { Apollo } from 'apollo-angular'
import { ApolloQueryResult } from '@apollo/client/core'
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { UserStatus } from 'common/aqsTypes'
import { MessageError, NotFoundError } from 'src/app/core/errors/errors'
import { safeGet } from '../../util/util'
import usernameConflictQuery from '../users-edit/username-conflict.gql'
import { username_conflict } from '../users-edit/types/username_conflict'
import setStatusMutation from './delete-users-details.gql'
import { set_user_status } from './types/set_user_status'
import { usersDetails } from './types/usersDetails'
import query from './users-details.gql'
import { NavService } from 'src/app/core/nav.service'

@Component({
  selector: 'app-users-details',
  templateUrl: './users-details.component.html',
  styleUrls: ['./users-details.component.scss'],
})
export class UsersDetailsComponent implements OnInit {
  @Input() userId: number

  loading = false

  editing = false

  private queryResult: ApolloQueryResult<usersDetails>

  safeGet = safeGet

  @Output() updateEvent = new EventEmitter()

  constructor(
    private apollo: Apollo,
    private route: ActivatedRoute,
    private nav: NavService,
  ) {}

  ngOnInit() {
    if (!this.userId) {
      this.userId = this.route.snapshot.params.id
    }
    this.fetchusersDetails()
  }

  fetchusersDetails = () => {
    this.loading = true
    this.apollo
      .query<usersDetails>({ query, variables: { id: this.userId } })
      .subscribe({ next: this.onNext, error: this.onError })
  }

  onNext = (result: ApolloQueryResult<usersDetails>) => {
    this.loading = false
    this.queryResult = result
    if (result.errors) {
      throw result.errors[0]
    }
    if (!this.user) {
      throw new NotFoundError('user', this.userId, ['home', 'users'])
    }
  }

  onError = (err: unknown) => {
    this.loading = false
    throw err
  }

  get user() {
    return this.queryResult?.data?.user_by_pk
  }

  get isDeleted() {
    return this.user?.status === UserStatus.deleted
  }

  delete() {
    if (
      window.confirm(
        'Delete User: the account will be disabled and hidden from lists; QC history is preserved. Are you sure?',
      )
    ) {
      this.setStatus(UserStatus.deleted, () => this.nav.navtree.users())
    }
  }

  reactivate() {
    this.apollo
      .query<username_conflict>({
        query: usernameConflictQuery,
        variables: { username: this.user.username, id: this.userId },
      })
      .subscribe({
        next: (result) => {
          if (result.errors) {
            throw result.errors[0]
          }
          if (result.data.user.length > 0) {
            throw new MessageError(
              `Username "${this.user.username}" is in use by another user. Change this user's username before reactivating.`,
            )
          }
          if (window.confirm('Reactivate User: are you sure?')) {
            this.setStatus(UserStatus.active, this.fetchusersDetails)
          }
        },
        error: this.onError,
      })
  }

  private setStatus(status: UserStatus, onDone: () => void) {
    this.apollo
      .mutate<set_user_status>({
        mutation: setStatusMutation,
        variables: { id: this.userId, status },
      })
      .subscribe({
        next: (result) => {
          if (result.errors) {
            throw result.errors[0]
          }
          onDone()
        },
        error: this.onError,
      })
  }

  editView() {
    this.editing = true
  }

  onSave($event) {
    this.editing = false
    this.updateEvent.emit($event)
    this.fetchusersDetails()
  }
}
